// extracted by mini-css-extract-plugin
export var actions = "_lq-g";
export var benefitCard = "_lq-b";
export var benefitIcon = "_lq-d";
export var benefitLabel = "_lq-f";
export var benefits = "_lq-a";
export var benefitsSection = "_lq-8";
export var bodyText = "_lq-7";
export var closeButton = "_lq-2";
export var content = "_lq-3";
export var eyebrow = "_lq-4";
export var heading = "_lq-5";
export var image = "_lq-i";
export var imagePanel = "_lq-h";
export var modal = "_lq-0";
export var offerCard = "_lq-c";
export var offerIcon = "_lq-e";
export var sectionLabel = "_lq-9";
export var shell = "_lq-1";
export var title = "_lq-6";